
import React from 'react';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 rounded-t-3xl mx-8 mb-6 py-16 relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 text-white/5 text-9xl font-extrabold whitespace-nowrap pointer-events-none select-none">
        DIREITOS DO PASSAGEIRO
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-3xl font-bold text-white mb-3 font-serif">
              Skarlett Marcelino
            </h3>
            <p className="text-white/70 text-sm mb-4">OAB/ES 34.325</p>
            <p className="text-white/80 text-sm leading-relaxed max-w-xs">
              Advocacia especializada em direitos do passageiro aéreo. Análise
              gratuita e sem compromisso.
            </p>
          </div>

          <div>
            <h4 className="text-base font-medium text-white mb-6">
              <a href="#direitos" className="hover:text-teal-500 transition-colors">
                Navegação
              </a>
            </h4>
            <ul className="space-y-3.5">
              <li>
                <button
                  onClick={() => scrollToSection('quanto-receber')}
                  className="text-sm text-white/70 hover:text-teal-500 transition-colors cursor-pointer"
                >
                  Quanto Posso Receber
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('como-funciona')}
                  className="text-sm text-white/70 hover:text-teal-500 transition-colors cursor-pointer"
                >
                  Como Funciona
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('depoimentos')}
                  className="text-sm text-white/70 hover:text-teal-500 transition-colors cursor-pointer"
                >
                  Depoimentos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contato')}
                  className="text-sm text-white/70 hover:text-teal-500 transition-colors cursor-pointer"
                >
                  Análise Gratuita
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-medium text-white mb-6">
              <a href="#contato" className="hover:text-teal-500 transition-colors">
                Contato
              </a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-teal-500"></i>
                <a
                  href="https://wa.me/5528998813826"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-sm text-white/80 hover:text-teal-500 transition-colors"
                >
                  (28) 99881-3826
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-medium text-white mb-3">
              <a href="#contato" className="hover:text-teal-500 transition-colors">
                Seus Direitos Importam
              </a>
            </h4>
            <p className="text-sm text-white/70 leading-relaxed mb-6">
              Não deixe a companhia aérea sair impune. Descubra gratuitamente se
              você tem direito a indenização.
            </p>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-sm font-bold text-teal-400 hover:text-teal-300 transition-colors flex items-center gap-2 cursor-pointer"
            >
              Fazer análise gratuita
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div className="border-t border-white/15 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            <p className="text-xs text-white/60 leading-relaxed max-w-3xl">
              &copy; 2025 Skarlett Marcelino &mdash; OAB/ES 34.325. Este site tem
              car&aacute;ter exclusivamente informativo. O conte&uacute;do n&atilde;o
              constitui promessa de resultado ou garantia de &ecirc;xito. Os
              valores mencionados s&atilde;o estimativas baseadas em
              jurisprud&ecirc;ncia e n&atilde;o garantem resultado
              id&ecirc;ntico. Atendimento em conformidade com o C&oacute;digo de
              &Eacute;tica e Disciplina da OAB e Provimento n&ordm; 205/2021.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-white/60 hover:text-teal-500 transition-colors whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
